import { Link } from "react-router-dom";
import { categories } from "@/mocks/siteData";

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  imageUrl: string;
}

export default function ArticleCard({ slug, title, excerpt, category, imageUrl }: ArticleCardProps) {
  const catInfo = categories.find((c) => c.id === category);

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-accent-300 transition-all duration-300"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>
      <div className="p-5">
        {catInfo && (
          <span className="inline-block text-xs text-accent-500 bg-accent-50 px-2 py-1 rounded-full mb-3">
            {catInfo.name}
          </span>
        )}
        <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-accent-500 transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}